// --- ConfigurationRepository.ts ---
import { CookiesStorageService } from '@Engage.Data.Services';
import { Http, customTime } from '@Engage.Core';
import { StorageKeys } from "@Engage.Data.Constants";
class ConfigurationRepositoryClass {
    constructor() {
        this.http = new Http();
    }
    /**
     * Fetch publish settings from API
     */
    getPublishSettingsFromApi(resourceUrl, siteCode, configCode) {
        const pathToFile = `${resourceUrl}data/last_publish/${siteCode}__${configCode}.json?_=${customTime.get().getTime()}`;
        return this.http.get(pathToFile);
    }
    /**
     * Store publish settings in cookie
     */
    setPublishSettings(publishSettings) {
        CookiesStorageService.set(StorageKeys.PublishSettings, JSON.stringify(publishSettings), {
            isSecureValue: true,
            daysOfLife: 365 // 1 year for publish settings
        });
    }
    /**
     * Get publish settings from cookie
     */
    getPublishSettingsFromCookie() {
        const cookie = CookiesStorageService.get(StorageKeys.PublishSettings, { isSecureValue: true });
        return cookie ? JSON.parse(cookie) : null;
    }
}
export const ConfigurationRepository = new ConfigurationRepositoryClass();
